import type { Profile } from '@isbd/shared';
import { ensureUserProfile, kuunda, type User } from '@/lib/kuunda';

const PROFILE_RETRY_ATTEMPTS = 10;
const PROFILE_RETRY_DELAY_MS = 200;

export type EnsureProfileExtras = {
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  countryCode?: string;
  referredBy?: string | null;
  avatarUrl?: string | null;
};

export async function fetchProfile(userId: string): Promise<Profile | null> {
  const { data, error } = await kuunda
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .maybeSingle();
  if (error) {
    console.error(error);
    return null;
  }
  return data as Profile | null;
}

export async function fetchProfileWithRetry(
  userId: string,
  attempts = PROFILE_RETRY_ATTEMPTS,
): Promise<Profile | null> {
  for (let i = 0; i < attempts; i++) {
    const profile = await fetchProfile(userId);
    if (profile) return profile;
    if (i < attempts - 1) {
      await new Promise((r) => setTimeout(r, PROFILE_RETRY_DELAY_MS));
    }
  }
  return null;
}

/** Crée le profil si besoin (RPC / trigger) puis attend sa disponibilité en base. */
export async function resolveUserProfile(
  user: User,
  extras?: EnsureProfileExtras,
): Promise<Profile | null> {
  await ensureUserProfile(user, extras);
  return fetchProfileWithRetry(user.id);
}
